"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
// @ts-ignore
var styled_components_1 = __importDefault(require("styled-components"));
var Ball = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 20px auto 20px auto;\n  border-radius: 50%;\n  height: 125px;\n  width: 125px;\n  background-color: #9c113f;\n  color: white;\n  font-family: 'Skatta Sans Black Condensed';\n  text-align: center;\n"], ["\n  margin: 20px auto 20px auto;\n  border-radius: 50%;\n  height: 125px;\n  width: 125px;\n  background-color: #9c113f;\n  color: white;\n  font-family: 'Skatta Sans Black Condensed';\n  text-align: center;\n"])));
var BatchSize = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 80px;\n  line-height: 0.9;\n  padding-top: 10px;\n"], ["\n  font-size: 80px;\n  line-height: 0.9;\n  padding-top: 10px;\n"])));
var Unit = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 20px;\n"], ["\n  font-size: 20px;\n"])));
var ProductBatchSize = function (_a) {
    var _b = _a.item, discountBatchSize = _b.discountBatchSize, unit = _b.unit;
    if (unit && discountBatchSize && discountBatchSize > 0) {
        return (react_1.default.createElement(Ball, null,
            react_1.default.createElement(BatchSize, null, discountBatchSize),
            react_1.default.createElement(Unit, null, unit)));
    }
    return react_1.default.createElement(react_1.Fragment, null);
};
exports.default = ProductBatchSize;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ProductBatchSize.js.map